export const AccessPermissionRole = {
  Administrator: "administrator",
  ChannelManager: "channel_manager",
  User: "user",
} as const

export type AccessPermissionRole = typeof AccessPermissionRole[keyof typeof AccessPermissionRole]
